/**
 * Resolve loan number and Vue Router location for in-app loan detail (`loan.detail`).
 * Uses API fields: loan_number, loan.loan_number, loan_view_path, loan_view_url.
 */

export function parseLoanNumberFromPathOrUrl(pathOrUrl) {
	if (!pathOrUrl || typeof pathOrUrl !== "string") {
		return null;
	}
	const trimmed = pathOrUrl.trim();
	if (!trimmed) {
		return null;
	}
	try {
		let path = trimmed;
		if (/^https?:\/\//i.test(trimmed)) {
			path = new URL(trimmed).pathname || "";
		}
		const parts = path.split("/").filter(Boolean);
		const i = parts.findIndex((p) => p === "loans");
		if (i >= 0 && parts[i + 1]) {
			return decodeURIComponent(parts[i + 1]);
		}
		return parts.length ? decodeURIComponent(parts[parts.length - 1]) : null;
	} catch {
		return null;
	}
}

export function resolveLoanNumberForLink(row) {
	if (!row) {
		return null;
	}
	const direct =
		row.loan_number != null && String(row.loan_number).trim() !== ""
			? String(row.loan_number).trim()
			: null;
	if (direct) {
		return direct;
	}
	const nested =
		row.loan &&
		row.loan.loan_number != null &&
		String(row.loan.loan_number).trim() !== ""
			? String(row.loan.loan_number).trim()
			: null;
	if (nested) {
		return nested;
	}
	if (row.loan_view_path) {
		const fromPath = parseLoanNumberFromPathOrUrl(row.loan_view_path);
		if (fromPath) {
			return fromPath;
		}
	}
	if (row.loan_view_url) {
		return parseLoanNumberFromPathOrUrl(row.loan_view_url);
	}
	return null;
}

export function displayLoanNumber(row) {
	const code = resolveLoanNumberForLink(row);
	return code || "—";
}

export function loanDetailRouteLocation(row) {
	const loan_number = resolveLoanNumberForLink(row);
	if (!loan_number) {
		return null;
	}
	return { name: "loan.detail", params: { loan_number } };
}
